import { CustomListNotifications } from "../Components/Lists/NotificationList";

export  function ListNotifications() {

    return(
        <>
          <CustomListNotifications/>
        </>
    );
  }